import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
// import Chip from "@material-ui/core/Chip";
import { Link } from 'react-router-dom';

import Section from '../../components/Section';
import SectionHeader from '../../components/SectionHeader';
import SectionBody from '../../components/SectionBody';

import { ReactComponent as Icon } from '../../assets/icons/Omni.svg';
import Image from '../../assets/icons/Omni_grey.svg';
//import constants from '../../main/constants';

const useStyles = makeStyles(() => ({
    content: {
        fontSize: 16,
        marginBottom: 20
    },
    list: {
        fontFamily: 'SourceSansPro-Regular',
        fontSize: 16,
        marginTop: 0,
    },
    listItem: {
        marginBottom: 20
    },
    chip: {
        backgroundColor: '#2598A3',
        color: 'white',
        height: 16,
        fontSize: 10,
        paddingTop: 1,
        marginLeft: 4
    },
    chipNew: {
        backgroundColor: '#8b68ea',
        color: 'white',
        height: 16,
        fontSize: 10,
        paddingTop: 1,
        marginLeft: 4
    },
    link: {
        color: '#1f96a2',
        cursor: 'pointer'
    },
    a: {
        color: '#1f96a2',
        cursor: 'pointer'
    }
}));

const Omnichannel = ({ setPage }) => {
    const classes = useStyles();

    return (
        <Section backgroundImage={Image}>
            <SectionHeader title="Omnichannel">
                <Icon width={40} height={40} />
            </SectionHeader>
            <SectionBody>
                <ul className={classes.list}>

                    <li className={classes.listItem}>
                        <a href='/docs/omnichannel/omnichannel/latest/installguide/introduction.html' target='_blank' className="linkText" underline='none' rel='noopener noreferrer'>Setup Environment</a>
                    </li>
                    <li className={classes.listItem}>
                        <a href='/docs/omnichannel/omnichannel/latest/tutorials/local-development.html' target='_blank' className='linkText' underline='none' rel='noopener noreferrer'>Tutorials</a>
                        {/* <Chip size="small" label="NEW" className={classes.chipNew} /> */}
                    </li>
                    <li className={classes.listItem}>
                        <a href="/docs/omnichannel" className="linkText" underline='none' rel='noopener noreferrer'>Documentation</a>

                    </li>
                    <li className={classes.listItem}>
                        Developer Training:
                        <ul className={classes.list}>
                            <li>
                                <a href={process.env.REACT_APP_DOCUMENTATION_TOOLKIT_UFE_URL} className="linkText" underline='none' rel='noopener noreferrer' target='_new'>Frontend</a>
                            </li>
                            <li>
                                <a href={process.env.REACT_APP_DOCUMENTATION_TOOLKIT_URL} className="linkText" underline='none' rel='noopener noreferrer' target='_new'>Backend</a>
                            </li>
                        </ul>

                    </li>
                    <li className={classes.listItem}><Link
                        className="linkText"
                        to={"/releaseversion/omni"}
                        underline='none'
                        rel='noopener noreferrer'>Releases & Changelog</Link>
                    </li>
                    <li className={classes.listItem}>
                        <Link
                            to={{ pathname: process.env.REACT_APP_GET_SUPPORT_DIGITAL_JOURNEY_URL }}
                            className="linkText"
                            underline='none'
                            target='_blank'
                            rel='noopener noreferrer'>
                            Support
                        </Link>
                    </li>
                    <li className={classes.listItem}>
                        <Link
                            to={{ pathname: process.env.REACT_APP_FEEDBACK_DIGITAL_JOURNEY_URL }}
                            className="linkText"
                            underline='none'
                            target='_blank'
                            rel='noopener noreferrer'>
                            Roadmap
                        </Link>
                    </li>

                </ul>
            </SectionBody>
        </Section>
    );

}

export default Omnichannel;
